<template>
  <el-dialog
    v-model="dialogVisible"
    destroy-on-close
    :width="500"
    :close-on-click-modal="false"
    :show-close="!isForce"
    class="p-8! pt-4! rounded-lg! box-border"
    title="修改密码"
    width="400"
  >
    <el-form :model="form" :rules="rulesPwd" ref="pwdRef">
      <el-form-item label="" prop="oldPwd" :label-width="0" v-if="isForce">
        {{ msg }}
      </el-form-item>
      <el-form-item label="旧密码" prop="oldPwd" :label-width="formLabelWidth">
        <el-input v-model="form.oldPwd" type="password" autocomplete="off" />
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd" :label-width="formLabelWidth">
        <el-input v-model="form.newPwd" type="password" autocomplete="off" />
      </el-form-item>
      <el-form-item label="确认新密码" prop="newPwdAgain" :label-width="formLabelWidth">
        <el-input v-model="form.newPwdAgain" type="password" autocomplete="off" />
      </el-form-item>
      <div style="color: red; text-align: center">*密码必须是数字和字母的组合，并且长度不小于6位</div>
    </el-form>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button
          type="primary"
          v-if="!isForce"
          plain
          @click="dialogVisible = false"
          class="w-[100px]"
          >取消</el-button
        >
        <el-button type="primary" @click="confirm" class="w-[100px]"> 确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { reactive, computed, ref } from 'vue'
import { updatePwd } from '@/api/user/index'
import { ElMessage } from 'element-plus'

import { useRouter } from 'vue-router'
import type { AxiosResponse } from 'axios'

const router = useRouter()
const formLabelWidth = '100px'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  msg: {
    type: String,
    default: '',
  },
  isForce: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

// 使用计算属性，通过get和set来实现双向绑定
const dialogVisible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const rulesPwd = reactive({
  oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
  newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
  newPwdAgain: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }],
})

const form = reactive({
  oldPwd: '',
  newPwd: '',
  newPwdAgain: '',
})

const pwdRef = ref()
const confirm = () => {
  pwdRef.value.validate(async (valid: unknown) => {
    if (!valid) return
    if(form.oldPwd === form.newPwd){
      ElMessage.warning('新旧密码不能相同')
      return
    }
    if (form.newPwd !== form.newPwdAgain) {
      ElMessage.warning('两次输入的密码不一致')
      return
    }
    //修改密码
    const query = {
      oldPwd: form.oldPwd,
      password: form.newPwd,
    }
    updatePwd(query).then((res: AxiosResponse) => {
      if (res.data.code == 200) {
        ElMessage.success('修改密码成功,请重新登录')
        dialogVisible.value = false
        const timer = setTimeout(() => {
          clearTimeout(timer)
          localStorage.clear()
          router.push('/login')
        }, 3000)
      }
    })
  })
}
</script>
